var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2346 12.9671H16.524V14.9013H18.4583V16.1908H16.524V18.125H15.2346V16.1908H13.3004V14.9013H15.2346V12.9671ZM11.3661 5.875C14.2159 5.875 16.524 7.02908 16.524 8.45395C16.524 9.87882 14.2159 11.0329 11.3661 11.0329C8.51641 11.0329 6.20825 9.87882 6.20825 8.45395C6.20825 7.02908 8.51641 5.875 11.3661 5.875ZM6.20825 9.74342C6.20825 11.1683 8.51641 12.3224 11.3661 12.3224C14.2159 12.3224 16.524 11.1683 16.524 9.74342V11.7292L15.8793 11.6776C14.2094 11.6776 12.7846 12.735 12.243 14.2179L11.3661 14.2566C8.51641 14.2566 6.20825 13.1025 6.20825 11.6776V9.74342ZM6.20825 12.9671C6.20825 14.392 8.51641 15.5461 11.3661 15.5461H12.0109C12.0109 16.223 12.185 16.8613 12.4944 17.4158L11.3661 17.4803C8.51641 17.4803 6.20825 16.3262 6.20825 14.9013V12.9671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDc);
export default __webpack_public_path__ + "static/media/newDc.e56b32c033f1324a7c827038e075dd5b.svg";
export { ForwardRef as ReactComponent };